<template>
  <div v-loading="$wait.waiting(_uid)" class="card training-program">
    <div class="card-content">
      <div class="row mt-s">
        <LightProgram :program="program" />
        <CalendarHeavy :program="program" />
        <LessLessonsThanPeriodicity :program="program" />
      </div>
      <div class="row mt-s">
        <ProgramTable :data="program" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import ProgramTable from "@/components/Dashboard/Views/Pages/Training/Components/ProgramTable.vue";
import MyService from "@app/services/my";
import LightProgram from "./Components/LightProgram.vue";
import CalendarHeavy from "./Components/CalendarHeavy.vue";
import LessLessonsThanPeriodicity from "./Components/LessLessonsThanPeriodicity.vue";

export default {
  components: {
    LessLessonsThanPeriodicity,
    CalendarHeavy,
    LightProgram,
    ProgramTable,
  },
  data() {
    return {
      program: {},
    };
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
  },
  async mounted() {
    try {
      this.$wait.start(this._uid);
      this.program = await MyService.getProgram();
    } catch (error) {
      this.addNewError(error);
    } finally {
      this.$wait.end(this._uid);
    }
  },
  methods: {
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("errorStore", ["addNewError"]),
  }
};
</script>

<style lang="scss"></style>
